module.exports = __webpack_public_path__ + "img/GH-kyujin-top-005.54ba191e.webp";